import { connect } from 'react-redux';
import CetakRaportMan from '../../../views/Kurikulum/Ulangan/CetakRaportMan.view';
import { getStudent } from '../../../states/thunks/student.thunk';
import { getLembarDaftarNilaiMan } from '../../../states/thunks/academics.thunk';
import { getPeriodsOptions, getParamOptionsAcademics } from '../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    result: state.result,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
    handleGetDaftarNilaiMan: payload => dispatch(getLembarDaftarNilaiMan(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CetakRaportMan);
